import { Permission } from '~/types/Permission';

import { canUseWorkflow } from './canUseWorkflow';
import { checkIsWorkflowAdmin } from './checkIsWorkflowAdmin';
import { and } from './utils/and';

export const canUseWorkflowAdmin: Permission = and([
  canUseWorkflow,
  checkIsWorkflowAdmin,
]);
